import { CREATE_ONDC_ISSUE_URL, FETCH_ISSUE_URL, FETCH_ISSUES_ACTION_TYPES_URL, FETCH_ISSUES_INFO_TYPES_URL, FETCH_ISSUES_RESOLUTION_TYPES_URL, FETCH_ISSUES_URL, FETCH_ONDC_SERVER_TYPES_URL, UPDATE_ISSUES_ACTIONS_URL } from 'src/constants/services';
import axios from 'src/utils/axios';

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InN1bmlsLnBhcnRlQG1pbmRzY2xpay5jb20iLCJtb2JpbGUiOiI4MTA1MDU3NTg1IiwibmFtZSI6IlN1bmlsIFBhcnRlIiwidXNlclR5cGUiOiJTVVBFUl9BRE1JTiIsImN1c3RvbWVySWQiOm51bGwsInVzZXJJZCI6MjIsImxpY2Vuc2VFeHBpcnkiOiIyMDI4LTA2LTAzVDEyOjEzOjQwLjY3N1oiLCJpYXQiOjE3NDg5NTI4MjAsImV4cCI6MTc0OTAzOTIyMH0.Ff0-fW7vnkskSOBBpsFVjbRUOdoT2V0v7x0oyjmO_nw";

class IssuesService {

    fetchIssues = (customerId) => new Promise((resolve, reject) => {

        

        axios
            .get(`${FETCH_ISSUES_URL}?customerId=${customerId}`)
            // .get("https://mperito.com/api/order/ondc/issues?customerId=109", { headers: { Authorization: `Bearer ${token}`}})
            .then((response) => {
                console.log("IssuesService(fetchIssues->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchIssues)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchIssues (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })

    fetchIssue = (customerId, issueId) => new Promise((resolve, reject) => {
        axios
            .get(`${FETCH_ISSUE_URL}?customerId=${customerId}&issueId=${issueId}`)
            //.get(`https://mperito.com/api/order/ondc/issue-details?customerId=${customerId}&issueId=${issueId}`, { headers: { Authorization: `Bearer ${token}`}})
            .then((response) => {
                console.log("IssuesService(fetchIssue->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchIssue)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchIssue (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })

    fetchIssuesResolutionTypes = () => new Promise((resolve, reject) => {
        axios
            .get(`${FETCH_ISSUES_RESOLUTION_TYPES_URL}`)
            .then((response) => {
                console.log("IssuesService(fetchIssuesResolutionTypes->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchIssuesResolutionTypes)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchIssuesResolutionTypes (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })

    fetchIssuesActionTypes = () => new Promise((resolve, reject) => {
        axios
            .get(`${FETCH_ISSUES_ACTION_TYPES_URL}`)
            .then((response) => {
                console.log("IssuesService(fetchIssuesActionTypes->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchIssuesActionTypes)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchIssuesActionTypes (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })

    fetchIssuesInfoTypes = () => new Promise((resolve, reject) => {
        axios
            .get(`${FETCH_ISSUES_INFO_TYPES_URL}`)
            .then((response) => {
                console.log("IssuesService(fetchIssuesInfoTypes->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchIssuesInfoTypes)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchIssuesInfoTypes (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })

    updateIssuesAction = (payload) =>
        new Promise((resolve, reject) => {
            // const payload = { issueid: issueId, action, resolution: resolutionType };

            console.log("IssuesService.updateIssuesAction:" + JSON.stringify(payload));

            axios
                .post(UPDATE_ISSUES_ACTIONS_URL, payload)
                .then((response) => {
                    console.log("IssuesService(Response)updateIssuesAction: " + JSON.stringify(response));

                    if (response.data) {
                        let data = response.data;
                        resolve(data);
                    } else {
                        reject(response.data.error);
                    }
                })
                .catch((error) => {
                    //console.log("IssuesService.updateIssuesAction (Response Error):" + JSON.stringify(error));
                    reject(error);
                });
        });

    
    createONDCIssues = (payload, preferredServerType) =>
        new Promise((resolve, reject) => {
    console.log("IssuesService.createONDCIssues (payload):", payload);

    // Build FormData
    const formData = new FormData();
    formData.append("serverType", preferredServerType);
    formData.append("ondcOrderId", payload.ondcOrderId);
    // formData.append("ondcOrderId", payload.ondcOrderId);
    formData.append("itemId", payload.itemId);
    formData.append("expectedResponseTime", payload.expectedResponseTime);
    formData.append("expectedResolutionTime", payload.expectedResolutionTime);
    formData.append("level", payload.level);
    formData.append("descriptionShort", payload.descriptionShort);
    formData.append("descriptionLong", payload.descriptionLong);

    formData.append("issueData", JSON.stringify( {
        serverType: preferredServerType,
        ondcOrderId: payload.ondcOrderId,
        itemId: payload.itemId,
        expectedResponseTime: payload.expectedResponseTime,
        expectedResolutionTime: payload.expectedResolutionTime,
        level: payload.level,
        descriptionShort: payload.descriptionShort,
        descriptionLong: payload.descriptionLong
    }));

    // Append images if available
    if (payload.images && payload.images.length > 0) {
      payload.images.forEach((file, index) => {
        if(index == 0 ) {
            formData.append("descriptionImage", file);
        } else {
            formData.append("additionalImage", file);
        }
        // formData.append("images", file); // backend should accept "images" as array
      });
    }

    axios
      .post(CREATE_ONDC_ISSUE_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("IssuesService.createONDCIssues (Response):", response);
        if (response.data) {
          resolve(response.data);
        } else {
          reject("No data in response");
        }
      })
      .catch((error) => {
        console.error("IssuesService.createONDCIssues (Error):", error);
        reject(error);
      });
  });


  fetchONDCServerType = () => new Promise((resolve, reject) => {
        axios
            .get(`${FETCH_ONDC_SERVER_TYPES_URL}`)
            .then((response) => {
                console.log("IssuesService(fetchONDCServerType->Response): 1", response);
                if (response.data) {
                    let issues = response.data?.data;
                    console.log("IssuesService(fetchONDCServerType)", issues);
                    resolve(issues);
                } else {
                    reject(response.data.error);
                }
            })
            .catch((error) => {
                console.log("IssuesService.fetchONDCServerType (Response Error):" + JSON.stringify(error));
                reject(error);
            });
    })


}

const issuesService = new IssuesService();
export default issuesService;
